module.exports = __webpack_public_path__ + "static/media/Postcard_Masary_Standard_vB copy.e28e6743.jpg";